<template>
  <div class="account-billing-details-display">
    <div class="row">
      <div class="col-sm-12">
        <div class="toolbar pull-right">
          <router-link class="btn btn-default" :to="{ path: `/membership/members/${account.uuid}` }">
            <span class="fa fa-user fa-fw"></span> Account Details
          </router-link>
          <router-link class="btn btn-default" :to="`/membership/members/files/${account.uuid}`">
            <span class="fa fa-file fa-fw"></span> Account Files
          </router-link>
          <template v-if="isFinanceAdmin">
            <a class="btn btn-default"
            :href="`https://dashboard.stripe.com/customers/${account.stripeAccount}`"
             target="_blank">
              <span class="fab fa-cc-stripe fa-fw"></span> View On Stripe
            </a>
            <div class="btn-group">
              <button type="button" class="btn btn-default dropdown-toggle"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="fa fa-dollar-sign"></span>
                Billing Actions <span class="caret"></span>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="interactive-cursor" @click="addCreditsModal()">
                    <span class="fa fa-dollar-sign fa-fw"></span> Add Credits
                  </a>
                </li>
                <li role="separator" class="divider"></li>
                <li>
                  <a class="interactive-cursor" @click="chargeModal()">
                    <span class="fa fa-credit-card fa-fw"></span> Charge Account
                  </a>
                </li>
              </ul>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 fixed">
        <div class="box box-primary">
          <div class="box-header">
            <h1 class="box-title">Filter By Date</h1>
          </div>
          <div class="box-body">
            <div class="list-group-item">
              <!-- <object-select-input :options="year" v-model="year.value" ref="yearSelect"></object-select-input> -->
              <br/>
              <!-- <month-select-input :field="month"></month-select-input> -->
              <div class="row">
                <div class="col-sm-12 text-right">
                  <button class="btn btn-warning" @click="clearValues()"><span class="fa fa-ban"></span> Clear</button>
                  <button class="btn btn-info" @click="refreshData()"><span class="fa fa-sync"></span> Refresh</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary">
          <div class="box-header">
            <h1 class="box-title">Account Details</h1>
          </div>
          <div class="box-body">
            <div class="list-group-item">
              <div class="row">
                <div class="col-xs-3 col-sm-4 col-md-5">
                  <p><strong>Full Name</strong></p>
                </div>
                <div class="col-xs-9 col-sm-8 col-md-7">
                  <p>
                    <router-link class="interactive-cursor" :to="{ path: `/membership/members/${account.uuid}` }">
                      {{ account.fullName }}
                    </router-link>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-3 col-sm-4 col-md-5">
                  <p>
                    <strong>Date of Birth</strong>
                  </p>
                </div>
                <div class="col-xs-9 col-sm-8 col-md-7">
                  <p>
                    {{ account.dateOfBirth | short_date_format }}
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-3 col-sm-4 col-md-5">
                  <p>
                    <strong>Date Joined</strong>
                  </p>
                </div>
                <div class="col-xs-9 col-sm-8 col-md-7">
                  <p>
                    {{ account.registeredDate | short_date_format }}
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-3 col-sm-4 col-md-5">
                  <p>
                    <strong>Account Type</strong>
                  </p>
                </div>
                <div class="col-xs-9 col-sm-8 col-md-7">
                  <p>{{ account.AccountType.name }} <span v-if="account.Master">(Driver)</span></p>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-3 col-sm-4 col-md-5">
                  <p><strong>Total Account Sales</strong></p>
                </div>
                <div class="col-xs-9 col-sm-8 col-md-7">
                  <strong>
                    {{ accountPayments | currency_round }}
                  </strong>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-3 col-sm-4 col-md-5">
                  <p><strong>Total Account Payments</strong></p>
                </div>
                <div class="col-xs-9 col-sm-8 col-md-7">
                  <strong>
                    {{ accountPayments | currency_round }}
                  </strong>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-3 col-sm-4 col-md-5">
                  <p><strong>Driving Credits Given</strong></p>
                </div>
                <div class="col-xs-9 col-sm-8 col-md-7">
                  <strong>{{ creditsGiven | currency_round }}</strong>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-3 col-sm-4 col-md-5">
                  <p><strong>Current Driving Credits</strong></p>
                </div>
                <div class="col-xs-9 col-sm-8 col-md-7">
                  <strong :class="{ 'text-danger' : account.credits < 0 }">
                    {{ account.credits | currency_round_neg }}
                  </strong>
                </div>
              </div>
            </div>
            <div class="box-header">
              <h1 class="box-title">Credit Cards <span class="label label-info label-margin">
                {{cards.length}}
              </span></h1>
            </div>
            <div class="list-group-item" v-if="cards.length == 0">
              Member has not added any credit cards.
            </div>
            <template v-for="card in cards">
              <div class="list-group-item">
                <span :class="card.icon + ' fa-lg'"></span> {{ card.dropdownLabel }}
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="col-md-8 offset-sm-4">
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs">
            <li class="active"><a href="#tab_1" data-toggle="tab" aria-expanded="false"><span class="fa fa-fw fa-file-alt"></span> Member Ledger</a></li>
            <li class="" v-if="isFinanceAdmin">
              <a href="#tab_2" data-toggle="tab" aria-expanded="false"><span class="fa fa-fw fa-credit-card"></span> Charges</a>
            </li>
          </ul>
          <div class="box">
            <div class="box-body">
              <div class="tab-content">
                <div class="tab-pane active" id="tab_1">
                  <h2 class="box-title">{{ month.value }} - {{ year.value }}</h2>
                  <button @click="prevMonth()" class="btn btn-info"><span class="fa fa-chevron-left fa-fw"></span> Prev Month</button>
                  <button :disabled="currentMonth" @click="nextMonth()" class="btn btn-info">Next month <span class="fa fa-chevron-right fa-fw"></span></button>
                  <responsive-table :table.sync="ledger"></responsive-table>
                </div>
                <div class="tab-pane" id="tab_2" v-if="isFinanceAdmin">
                  <h2 class="box-title">{{ month.value }} - {{ year.value }}</h2>
                  <button @click="prevMonth()" class="btn btn-info"><span class="fa fa-chevron-left fa-fw"></span> Prev Month</button>
                  <button :disabled="currentMonth" @click="nextMonth()" class="btn btn-info">Next month <span class="fa fa-chevron-right fa-fw"></span></button>
                  <div class="box box-primary">
                    <div class="box-header">
                      <h1 class="box-title">Charge History</h1>
                    </div>
                    <div class="box-body">
                      <responsive-table :table.sync="charges"></responsive-table>
                      <paging-input v-ref:reservation-charge-paging :options="reservationChargePagingOptions"></paging-input>
                      <responsive-table :table.sync="heldCharges"></responsive-table>
                      <paging-input v-ref:held-charge-paging :options="heldChargePagingOptions"></paging-input>
                      <responsive-table :table.sync="bulkCharges"></responsive-table>
                      <paging-input v-ref:bulk-charge-paging :options="bulkChargePagingOptions"></paging-input>
                    </div>
                  </div>
                  <div class="box box-primary">
                    <div class="box-header">
                      <h1 class="box-title">Credit History</h1>
                    </div>
                    <div class="box-body">
                      <responsive-table :table.sync="creditsUsed"></responsive-table>
                      <paging-input v-ref:credit-usage-paging :options="creditUsagePagingOptions"></paging-input>
                      <responsive-table :table.sync="creditsAdded"></responsive-table>
                      <paging-input v-ref:credits-added-paging :options="creditsAddedPagingOptions"></paging-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- charge modal -->
    <modal ref="chargeModal" v-if="charging">
      <template slot="header">
        <h4 class="modal-title">Charge Account</h4>
      </template>
      <template slot="body">
        <form class="form form-horizontal" ref="chargeForm">
          <template v-for="(charge, index) in chargeItems">
            <text-input v-if="charge.type === 'text'" :field="charge"></text-input>
            <object-select-input v-if="charge.type === 'mua'" :field="charge"></object-select-input>
            <custom-charge-input v-if="charge.type === 'custom'" :field="charge"></custom-charge-input>
            <div class="row move-up" v-if="charge.type !== 'text'">
              <div class="col-sm-8 offset-sm-4">
                <a class="interactive-cursor" @click="removeCharge(index)"><span class="fa fa-times fa-fw"></span> Remove</a>
              </div>
            </div>
          </template>
          <div class="row">
            <div class="col-sm-8 offset-sm-4">
              <p><button type="button" class="btn btn-default btn-xs charge-button" @click="addMuaCharge()"><span class="fa fa-plus fa-fw"></span> Add MUA charge</button></p>
              <p><button type="button" class="btn btn-default btn-xs charge-button" @click="addCustomCharge()"><span class="fa fa-plus fa-fw"></span> Add custom charge </button></p>
            </div>
          </div>
          <object-select-input :field="cardDropDown"></object-select-input>
          <textarea-input :field="chargeComments"></textarea-input>
          <div class="row">
            <div class="col-sm-8 offset-sm-4">
              <div class="callout callout-info">
                <strong>Member will not see these comments. The comments will just go onto an associated account note and are for internal use only.</strong>
              </div>
            </div>
          </div>
          <responsive-table v-if="chargeItems.length > 1" :table="chargeStatement"></responsive-table>
        </form>
        <div class="row" v-show="formError">
          <div class="col-sm-8 offset-sm-4">
            <div class="form-section-danger">
              {{ formError }}
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button class="btn btn-default pull-left" data-dismiss="modal" type="button">Cancel</button>
        <button @click="chargeAccount()" class="btn btn-danger" type="button">Charge</button>
      </template>
    </modal>
    <!-- refund modal -->
    <modal ref="refundModal" v-if="refunding">
      <template slot="header">
        <h4 class="modal-title">Refund Charge</h4>
      </template>
      <template slot="body">
        <p>Refund: {{ refundCharge.description }}</p>
        <p>The amount of ${{ refundCharge.cost || refundCharge.amount }} will be refunded. Please enter your reason for refunding this charge below:</p>
        <textarea v-model="refundReason"></textarea>
        <div v-if="noReason" class="alert alert-danger">
          Please enter a reason for refunding this charge before processing it.
        </div>
      </template>
      <template slot="footer">
        <button class="btn btn-default pull-left" data-dismiss="modal" type="button">Cancel</button>
        <button @click="refund()" class="btn btn-success" type="button">Refund</button>
      </template>
    </modal>
    <!-- charge complete modal -->
    <modal ref="completeModal" v-if="completing">
      <template slot="header">
        <h4 class="modal-title">Success</h4>
      </template>
      <template slot="body">
        <div v-html="message"></div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from '../Modal'
import ReservationDisplay from './ReservationDisplay'
import AccountNoteDisplay from './AccountNoteDisplay'
import TextInput from '../inputs/TextInput'
import TextareaInput from '../inputs/TextareaInput'
import CurrencyInput from '../inputs/CurrencyInput'
// import DateInput from '../inputs/DateInput'
import CustomChargeInput from '../inputs/CustomChargeInput'
import PagingInput from '../inputs/PagingInput'
import ObjectSelectInput from '../inputs/ObjectSelectInput'
// import MonthSelectInput from '../inputs/MonthSelectInput'
import ResponsiveTable from '../ResponsiveTable'

export default {
  name: 'AccountBillingDetailsDisplay',
  components: {
    ReservationDisplay,
    // MonthSelectInput,
    ResponsiveTable,
    AccountNoteDisplay,
    CurrencyInput,
    Modal,
    TextInput,
    TextareaInput,
    ObjectSelectInput,
    PagingInput,
    CustomChargeInput
  },
  data () {
    return {
      month: {
        name: 'month',
        value: moment().format('MMM'),
        label: 'Month'
      },
      year: {
        name: 'year',
        label: 'Year',
        value: '',
        objects: [],
        valid: false,
        dirty: false,
        singleLabel: 'Year',
        objectName: 'uuid'
      },
      noReason: false,
      refundCharge: {},
      refundReason: '',
      reservationChargeOffset: 0,
      reservationChargeLimit: 10,
      reservationChargePagingOptions: {
        totalResults: 10,
        limit: 10,
        current: 1
      },
      creditUsageOffset: 0,
      creditUsageLimit: 10,
      creditUsagePagingOptions: {
        totalResults: 10,
        limit: 10,
        current: 1
      },
      creditsAddedOffset: 0,
      creditsAddedLimit: 10,
      creditsAddedPagingOptions: {
        totalResults: 10,
        limit: 10,
        current: 1
      },
      bulkChargeOffset: 0,
      bulkChargeLimit: 10,
      bulkChargePagingOptions: {
        totalResults: 10,
        limit: 10,
        current: 1
      },
      heldChargeOffset: 0,
      heldChargeLimit: 10,
      heldChargePagingOptions: {
        totalResults: 10,
        limit: 10,
        current: 1
      },
      heldCharges: {
        title: 'Preauthorisation',
        count: 0,
        columns: [],
        rows: []
      },
      bulkCharges: {
        title: 'Other Charges',
        count: 0,
        columns: [],
        rows: []
      },
      chargeStatement: {
        title: 'Statement of Charges',
        columns: [
          { title: 'Description', span: 6, name: 'description', type: 'text' },
          { title: 'Amount', span: 6, name: 'amount', type: 'text' }
        ],
        rows: []
      },
      account: {
        AccountType: {}
      },
      credits: 0,
      cards: [],
      charges: {
        title: 'Reservation Charges',
        count: 0,
        columns: [],
        rows: []
      },
      creditsUsed: {
        title: 'Account Credit Usage',
        count: 0,
        columns: [],
        rows: []
      },
      creditsAdded: {
        title: 'Account Credits Added',
        count: 0,
        columns: [],
        rows: []
      },
      crediting: false,
      creditReason: {
        name: 'creditReason',
        label: 'Credit Reason (member will see this)',
        value: '',
        placeholder: 'EG: Credit given by Greensharecar',
        valid: false,
        dirty: false
      },
      creditExpiry: {
        name: 'expiryDate',
        label: 'Expiry Date',
        value: null,
        valid: false,
        dirty: false
      },
      creditAmount: {
        name: 'creditAmount',
        label: 'Credit Amount',
        value: 0,
        valid: false,
        dirty: false
      },
      charging: false,
      chargeComments: {
        name: 'comments',
        label: 'Comments',
        value: '',
        valid: false,
        dirty: false,
        height: '100px'
      },
      chargeItems: [
        {
          name: 'chargeName',
          label: 'Charge Description',
          required: true,
          value: '',
          valid: false,
          dirty: false,
          type: 'text'
        }
      ],
      message: '',
      completing: false,
      accountFees: [],
      formError: false,
      accountPayments: 0,
      creditsGiven: 0,
      accountSales: 0,
      cardDropDown: {
        name: 'card',
        label: 'Credit Cards',
        value: '',
        objects: [],
        valid: false,
        dirty: false,
        singleLabel: 'Credit Card',
        objectName: 'dropdownLabel',
        required: true
      },
      refunding: false,
      ledger: {
        title: 'Member Ledger',
        count: 0,
        columns: [],
        rows: []
      },
      isFinanceAdmin: false
    }
  },
  route: {
    data () {
      this.refreshData()
      this.getTotalAccountPayments()
      this.getTotalAccountSales()
      this.getTotalCreditsGiven()
    }
  },
  computed: {
    currentMonth () {
      let selectedDate = moment(`${this.month.value} ${this.year.value}`, 'MMM YYYY').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      let currentDate = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      return selectedDate.isSame(currentDate)
    }
  },
  events: {
    refundModal (charge) {
      this.refundCharge = Array.isArray(charge) ? charge[0] : charge
      this.refunding = true
      this.$nextTick(function () {
        $(this.$refs.refundModal).modal()
        $(this.$refs.refundModal).on('hidden.bs.modal', (e) => {
          this.refunding = false
          this.noReason = false
          this.refundReason = ''
        })
      })
    },
    captureModal (charge) {
      this.captureReservation.value = ''
      this.captureCharge = Array.isArray(charge) ? charge[0] : charge
      this.captureReservation.objects = this.captureCharge.Reservations
      this.capturing = true
      this.$nextTick(function () {
        $(this.$refs.captureModal).modal()
        $(this.$refs.captureModal).on('hidden.bs.modal', (e) => {
          this.capturing = false
          this.captureAmount = 0
          this.captureReason = ''
          this.captureError = false
        })
      })
    },
    valueChanged () {
      let total = 0
      this.chargeStatement.rows = []
      this.chargeItems.forEach(item => {
        if (item.type === 'mua') {
          let charge = {}
          for (let i of item.objects) {
            i.children.find(function (el, i, arr) {
              if (el.uuid === item.value) {
                charge = el
                return true
              }
            })
          }
          this.chargeStatement.rows.push(
            {
              description: charge.name, amount: '$' + charge.amount
            }
          )
          total += parseFloat(charge.amount)
        } else if (item.type === 'custom') {
          this.chargeStatement.rows.push(
            {
              description: item.descriptionValue, amount: '$' + item.amountValue
            }
          )
          total += parseFloat(item.amountValue)
        }
      })
      this.chargeStatement.rows.push(
        {
          description: '', amount: ''
        }
      )
      this.chargeStatement.rows.push(
        {
          description: 'Total (Includes GST)', amount: '$' + total.toFixed(2)
        }
      )
    }
  },
  mounted () {
    this.$refs.reservationChargePaging.$on('changePage', function (page) {
      this.$parent.reservationChargeOffset = (page - 1) * this.$parent.reservationChargeLimit
      this.$parent.getCharges()
    })
    this.$refs.creditUsagePaging.$on('changePage', function (page) {
      this.$parent.creditUsageOffset = (page - 1) * this.$parent.creditUsageLimit
      this.$parent.getCreditsUsed()
    })
    this.$refs.creditsAddedPaging.$on('changePage', function (page) {
      this.$parent.creditsAddedOffset = (page - 1) * this.$parent.creditsAddedLimit
      this.$parent.getCreditsAdded()
    })
    this.$refs.bulkChargePaging.$on('changePage', function (page) {
      this.$parent.bulkChargeOffset = (page - 1) * this.$parent.bulkChargeLimit
      this.$parent.getBulkCharges()
    })
    this.$refs.heldChargePaging.$on('changePage', function (page) {
      this.$parent.heldChargeOffset = (page - 1) * this.$parent.heldChargeLimit
      this.$parent.getHeldCharges()
    })
  },
  methods: {
    nextMonth () {
      let currentDate = moment(`${this.month.value} ${this.year.value}`, 'MMM YYYY')
      let nextMonth = currentDate.add(1, 'month')
      this.month.value = nextMonth.clone().format('MMM')
      this.year.value = nextMonth.clone().format('YYYY')
      this.refreshData()
    },
    prevMonth () {
      let currentDate = moment(`${this.month.value} ${this.year.value}`, 'MMM YYYY')
      let lastMonth = currentDate.subtract(1, 'month')
      this.month.value = lastMonth.clone().format('MMM')
      this.year.value = lastMonth.clone().format('YYYY')
      this.refreshData()
    },
    clearValues () {
      this.year.value = ''
      this.month.value = ''
      this.$refs.yearSelect.clearValue()
      this.refreshData()
    },
    capture () {
      this.captureError = false
      if (this.captureAmount > parseFloat(this.captureCharge.cost)) {
        this.captureError = 'You can only capture up to $' + this.captureCharge.cost
      } else if (!this.captureAmount || this.captureAmount === '0') {
        this.captureError = 'Please enter an amount to capture'
      } else if (!this.captureReason) {
        this.captureError = 'Please enter a reason for capturing this charge'
      } else if (!this.captureReservation.value) {
        this.captureError = 'Please choose a reservation'
      } else {
        this.captureError = false
        let { meta } = this.$route.matched.find(m => m.meta.authType)
        this.$http.post(`${meta.authType}/object/captureCharge`, {
          chargeToCapture: this.captureCharge,
          amountToCapture: this.captureAmount,
          captureReason: this.captureReason,
          accountUuid: this.account.uuid,
          reservation: this.captureReservation.value
        })
        .then(({ data }, status, request) => {
          if (data.object.error) {
            this.message = `
            <div class="stripe-error callout callout-danger">
            <p>${data.object.error}</p>
            </div>`
          } else {
            this.message = data.object.success
          }
          $(this.$refs.captureModal).modal('toggle')
          this.completing = true
          this.$nextTick(function () {
            $(this.$refs.completeModal).modal()
            $(this.$refs.completeModal).on('hidden.bs.modal', (e) => {
              this.captureAmount = 0
              this.completing = false
              this.refreshData()
            })
          })
        })
      }
    },
    refund () {
      this.noReason = false
      if (!this.refundReason) {
        this.noReason = true
      } else {
        let { meta } = this.$route.matched.find(m => m.meta.authType)
        this.$http.post(`${meta.authType}/object/refundCharge`, {
          chargeToRefund: this.refundCharge,
          refundReason: this.refundReason,
          accountUuid: this.account.uuid
        })
        .then(({ data }, status, request) => {
          if (data.object.error) {
            this.message = `
            <div class="stripe-error callout callout-danger">
            <p>${data.object.error}</p>
            </div>`
          } else {
            this.message = data.object.success
          }
          $(this.$refs.refundModal).modal('toggle')
          this.completing = true
          this.$nextTick(function () {
            $(this.$refs.completeModal).modal()
            $(this.$refs.completeModal).on('hidden.bs.modal', (e) => {
              this.noReason = false
              this.refundReason = ''
              this.completing = false
              this.refreshData()
            })
          })
        })
      }
    },
    removeCharge (index) {
      this.chargeItems.splice(index, 1)
    },
    addMuaCharge () {
      this.chargeItems.push({
        name: 'muaCharge',
        optgroup: true,
        label: 'MUA Charges',
        value: '',
        objects: this.accountFees,
        valid: false,
        dirty: false,
        singleLabel: 'Charge',
        objectName: 'text',
        type: 'mua',
        required: true
      })
    },
    addCustomCharge () {
      this.chargeItems.push({
        name: 'customCharge',
        optgroup: true,
        label: 'Custom Charge',
        descriptionValue: '',
        amountValue: '',
        descriptionRequired: true,
        amountRequired: true,
        descriptionName: 'customChargeDescription',
        amountName: 'customChargeAmount',
        descriptionValid: false,
        amountValid: false,
        descriptionDirty: false,
        amountDirty: false,
        type: 'custom'
      })
    },
    getAccountFees () {
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/accountFees`, {}).then(({ data }, status, request) => {
        this.accountFees = data.object
      })
    },
    chargeModal () {
      this.charging = true
      this.$nextTick(function () {
        $(this.$refs.chargeModal).modal()
        $(this.$refs.chargeModal).on('hidden.bs.modal', (e) => {
          this.charging = false
        })
      })
    },
    chargeAccount () {
      let formValid = 0
      this.formError = false
      if (this.chargeItems.length < 2) {
        this.formError = 'You did not add any charges.'
      } else {
        this.chargeItems.forEach(function (item) {
          if (item.type === 'mua') {
            if (!item.valid || !item.value) {
              item.dirty = true
              formValid++
            }
          } else if (item.type === 'custom') {
            if (!item.descriptionValid) {
              item.descriptionDirty = true
              formValid++
            }
            if (!item.amountValid) {
              item.amountDirty = true
              formValid++
            }
          } else if (item.type === 'text') {
            if (!item.valid) {
              item.dirty = true
              formValid++
            }
          }
        })
        if (formValid > 0) {
          this.formError = 'You did not fill all fields correctly'
        } else {
          let { meta } = this.$route.matched.find(m => m.meta.authType)
          this.$http.post(`${meta.authType}/object/account/chargeFee`, {
            formData: this.chargeItems,
            AccountUuid: this.account.uuid,
            comments: this.chargeComments.value,
            selectedCard: this.cardDropDown.value
          }).then(({ data }, status, request) => {
            if (data.error) {
              this.message = `
              <div class="stripe-error callout callout-danger">
              <p>Stripe payment failed - Error message [ ${data.error} ].</p>
              <p>Amount taken from account credits in fallback.</p>
              </div>`
            } else {
              this.message = data.success
            }
            $(this.$refs.chargeModal).modal('toggle')
            this.completing = true
            this.$nextTick(function () {
              $(this.$refs.completeModal).modal()
              $(this.$refs.completeModal).on('hidden.bs.modal', (e) => {
                this.completing = false
                this.chargeComments = {
                  name: 'comments',
                  label: 'Comments',
                  value: '',
                  valid: false,
                  dirty: false,
                  height: '100px'
                }
                this.chargeItems = [
                  {
                    name: 'chargeName',
                    label: 'Charge Description',
                    required: true,
                    value: '',
                    valid: false,
                    dirty: false,
                    type: 'text'
                  }
                ]
                this.refreshData()
              })
            })
          })
        }
      }
    },
    addCreditsModal () {
      this.crediting = true
      this.$nextTick(function () {
        $(this.$refs.creditModal).modal()
        $(this.$refs.creditModal).on('hidden.bs.modal', (e) => {
          this.crediting = false
        })
      })
    },
    addCredits () {
      let formData = $(this.$refs.creditForm).serializeObject()
      formData.AccountUuid = this.account.uuid
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.post(`${meta.authType}/object/account/credit`,
      formData).then(({ data }, status, request) => {
        $(this.$refs.creditModal).modal('toggle')
        this.refreshData()
      })
    },
    refreshData () {
      this.reservationChargeOffset = 0
      this.reservationChargeLimit = 10
      this.reservationChargePagingOptions = {
        totalResults: 10,
        limit: 10,
        current: 1
      }
      this.creditUsageOffset = 0
      this.creditUsageLimit = 10
      this.creditUsagePagingOptions = {
        totalResults: 10,
        limit: 10,
        current: 1
      }
      this.creditsAddedOffset = 0
      this.creditsAddedLimit = 10
      this.creditsAddedPagingOptions = {
        totalResults: 10,
        limit: 10,
        current: 1
      }
      this.bulkChargeOffset = 0
      this.bulkChargeLimit = 10
      this.bulkChargePagingOptions = {
        totalResults: 10,
        limit: 10,
        current: 1
      }
      this.heldChargeOffset = 0
      this.heldChargeLimit = 10
      this.heldChargePagingOptions = {
        totalResults: 10,
        limit: 10,
        current: 1
      }
      let params = this.$route.params
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/accountBillingDetails`, { params }).then(({ data }, status, request) => {
        this.account = data.object.account
        this.cards = data.object.cards
        this.cardDropDown.objects = this.cards
        let startYear = moment(this.account.registeredDate).year()
        let thisYear = moment().year()
        if (this.year.objects.length === 0) {
          while (startYear <= thisYear) {
            this.year.objects.push({ uuid: startYear })
            startYear++
          }
          this.year.value = moment().format('YYYY')
        }
        this.$http.get(`${this.$route.authType}/object/account`, { params }).then(({ data }, status, request) => {
          this.isFinanceAdmin = data.object.isFinanceAdmin
          if (this.isFinanceAdmin) {
            this.getCharges()
            this.getCreditsUsed()
            this.getCreditsAdded()
            this.getAccountFees()
            this.getBulkCharges()
            this.getHeldCharges()
          }
          this.getLedger()
        })
      })
    },
    getCharges () {
      let params = {
        account_id: this.$route.params.account_id,
        offset: this.reservationChargeOffset,
        limit: this.reservationChargeLimit,
        year: this.year.value,
        month: this.month.value
      }
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/accountCharges`, { params }).then(({ data }, status, request) => {
        this.charges = data.object.rows
        this.reservationChargePagingOptions.current = (this.reservationChargeOffset / this.reservationChargeLimit) + 1
        this.reservationChargePagingOptions.totalResults = data.object.count
        this.reservationChargePagingOptions.limit = this.reservationChargeLimit
        this.$nextTick(function () {
          this.$refs.reservationChargePaging.$emit('pagesUpdated', this.reservationChargePagingOptions)
        })
      })
    },
    getCreditsUsed () {
      let params = {
        account_id: this.$route.params.account_id,
        offset: this.creditUsageOffset,
        limit: this.creditUsageLimit,
        year: this.year.value,
        month: this.month.value
      }
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/accountCredits`, { params }).then(({ data }, status, request) => {
        this.creditsUsed = data.object.creditsUsed
        this.creditUsagePagingOptions.current = (this.creditUsageOffset / this.creditUsageLimit) + 1
        this.creditUsagePagingOptions.totalResults = data.object.count
        this.creditUsagePagingOptions.limit = this.creditUsageLimit
        this.$nextTick(function () {
          this.$refs.creditUsagePaging.$emit('pagesUpdated', this.creditUsagePagingOptions)
        })
      })
    },
    getCreditsAdded () {
      let params = {
        account_id: this.$route.params.account_id,
        offset: this.creditsAddedOffset,
        limit: this.creditsAddedLimit,
        year: this.year.value,
        month: this.month.value
      }
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/accountCreditsAdded`, { params }).then(({ data }, status, request) => {
        this.creditsAdded = data.object.creditsAdded
        this.creditsAddedPagingOptions.current = (this.creditsAddedOffset / this.creditsAddedLimit) + 1
        this.creditsAddedPagingOptions.totalResults = data.object.count
        this.creditsAddedPagingOptions.limit = this.creditsAddedLimit
        this.$nextTick(function () {
          this.$refs.creditsAddedPaging.$emit('pagesUpdated', this.creditsAddedPagingOptions)
        })
      })
    },
    getBulkCharges () {
      let params = {
        account_id: this.$route.params.account_id,
        offset: this.bulkChargeOffset,
        limit: this.bulkChargeLimit,
        year: this.year.value,
        month: this.month.value
      }
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/accountBulkCharges`, { params }).then(({ data }, status, request) => {
        this.bulkCharges = data.object.bulkCharges
        this.bulkChargePagingOptions.current = (this.bulkChargeOffset / this.bulkChargeLimit) + 1
        this.bulkChargePagingOptions.totalResults = data.object.count
        this.bulkChargePagingOptions.limit = this.bulkChargeLimit
        this.$nextTick(function () {
          this.$refs.bulkChargePaging.$emit('pagesUpdated', this.bulkChargePagingOptions)
        })
      })
    },
    getHeldCharges () {
      let params = {
        account_id: this.$route.params.account_id,
        offset: this.heldChargeOffset,
        limit: this.heldChargeLimit,
        year: this.year.value,
        month: this.month.value
      }
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/heldCharges`, { params }).then(({ data }, status, request) => {
        this.heldCharges = data.object.heldCharges.rows
        this.heldChargePagingOptions.current = (this.heldChargeOffset / this.heldChargeLimit) + 1
        this.heldChargePagingOptions.totalResults = data.object.heldCharges.count
        this.heldChargePagingOptions.limit = this.heldChargeLimit
        this.$nextTick(function () {
          this.$refs.heldChargePaging.$emit('pagesUpdated', this.heldChargePagingOptions)
        })
      })
    },
    getTotalAccountPayments () {
      let params = {
        account_id: this.$route.params.account_id
      }
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/totalAccountPayments`, { params }).then(({ data }, status, request) => {
        this.accountPayments = data.object
      })
    },
    getTotalAccountSales () {
      let params = {
        account_id: this.$route.params.account_id
      }
      this.$http.get(`${this.$route.authType}/object/totalAccountSales`, { params }).then(({ data }, status, request) => {
        this.accountSales = data.object
      })
    },
    getTotalCreditsGiven () {
      let params = {
        account_id: this.$route.params.account_id
      }
      this.$http.get(`${this.$route.authType}/object/totalCreditsGiven`, { params }).then(({ data }, status, request) => {
        this.creditsGiven = data.object
      })
    },
    getLedger () {
      let params = {
        account_id: this.$route.params.account_id,
        year: this.year.value,
        month: this.month.value
      }
      this.$http.get(`${this.$route.authType}/object/accountLedger`, { params }).then(({ data }, status, request) => {
        this.ledger = data.object.table
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/AccountBillingDetailsDisplay.vue